import React from 'react';	
import PropTypes from 'prop-types';	
import isDefined from '../components/shared/FormBuilder/utils/isDefined';	
import { bankFormList } from '../submissions/components/SelectForms';	
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';	
import MultiSelectCheckboxes from './MultiSelect';	
import validateRole from './formValueGenerator';
import { FormsList } from '../submissions/components/SelectForms';

 export default class MultipleCheckBoxC extends React.Component {	
    constructor(props) {	
        super(props);	
        const name = this.props.data.name;	
        const initialValue = this.props.initialValues[name];	
        const selectedforms = isDefined(initialValue) ? initialValue.split(',') : [];	
        const selectedformsArray = this.props.data.attributes.options.filter((option, index) => {	
            if (selectedforms.includes(option.value)) {	
                return (	
                    option	
                )	
            }	
        });	
        this.state = {	
            value: isDefined(initialValue) ? initialValue : [],	
            selectedOptions: isDefined(selectedformsArray) ? selectedformsArray : [],	
        };	
        this.handleChangeEvent = this.handleChangeEvent.bind(this);	
    }	

     componentWillReceiveProps(nextProps){	
        if(nextProps.hidden){	
            this.setState({value:'',selectedOptions:[]})	
        }	
    }	

     handleChangeEvent(event) {	
        let selectedValueArray = [];	
        event.map(object => {	
            selectedValueArray = [...selectedValueArray, object.value]	
        })	
        const insuredValue = selectedValueArray.toString();	
        this.setState({	
            value: insuredValue,	
            selectedOptions: event,	
        });	
        this.props.handleFormChange();	
    }	

     render() {
        let formOptions = this.props.data.attributes.options;
        const formNum = this.props.data.formsList;
        if (formNum) {

            // const formOptions_ = this.props.selectedRoles[formNum] && this.props.selectedRoles ?
            // validateRole(FormsList, this.props.selectedRoles[formNum]) : FormsList;
            const formOptions__ = this.props.selectedRelations && this.props.selectedRelations[formNum] ?
                validateRole(FormsList, this.props.selectedRelations[formNum]) : FormsList;
            formOptions = [...formOptions__];
            formOptions = [...new Set(formOptions)];
            // formOptions = formOptions.length<1 ? [...new Set(this.props.relationForms.initialRelationForms)] : formOptions;
        }
	
        return (	
            <div className="col-xs-12 pad_10_0 AdditionalInsuredSelectorContainer">	
                <label className="col-xs-4 quoteTitle">{this.props.data.text}	
                    {this.props.data.conditionalText && <div className="conditionalText">{this.props.data.conditionalText}</div>}	
                </label>	
                <div className="select">	
                    <div className="col-xs-8 nopad selectFormDropdown" id={this.props.data.name} value={this.state.value}>	
                        <MultiSelectCheckboxes className="col-xs-12"	
                            options={formOptions}	
                            value={this.state.selectedOptions}	
                            onChange={this.handleChangeEvent}	
                            placeholderButtonLabel=""	
                        />	
                    </div>	
                </div>	
                {this.props.data.showFormsList && bankFormList.map((forms, index) => {	
                    return (	
                        <div key={index} className="showForms">{forms}</div>	
                    );	
                })}	
                {this.props.data.helper && <div className="helper">{this.props.data.helper}</div>}	
            </div>	
        )	
    }	
}	
MultipleCheckBoxC.propTypes = {	
    handleFormChange: PropTypes.func,	
    initialValues: PropTypes.object,	
}; 